/** @jsx jsx */
import React from 'react'
import { css, jsx } from '@emotion/react'

export type MapAlertProps = {
  message: string
}

export const MapAlert = ({ message }: MapAlertProps) => {
  if (message.trim() === '') return null
  return (
    <div id="map_alert" css={rootStyle}>
      <div className="inner">{message}</div>
    </div>
  )
}

const rootStyle = css`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 5;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  outline: 0;
  background-color: rgba(15, 13, 3, 0.6);
  pointer-events: none;

  & .inner {
    text-align: center;
    font-size: 13px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    background: #fff;
    padding: 10px 18px;
    opacity: 0.9;
    border-radius: 5px;
  }
`
